import CluppRating from "../../../Components/CluppForms/CluppRating";
import TitleHeaders from "../../../Components/CluppForms/TitleHeaders";
import StarIcon from "@mui/icons-material/Star";

const RatingCluppService = ({ state, setState, field }) => {
  const labels = {
    1: "Malo",
    2: "Mejorable",
    3: "Regular",
    4: "Bueno",
    5: "Excelente",
  };

  return (
    <>
      <TitleHeaders
        title={"¿En general, cuanto le pondrías al servicio de Clupp?"}
        subtitle={
          "Por favor, selecciona una de las siguientes opciones de calificación."
        }
        isRequired={true}
      />
      <CluppRating
        labels={labels}
        rating={state[field]}
        field={field}
        setState={setState}
        Icon={StarIcon}
        size="40px"
        precision={1}
        haveNumbers={true}
      />
    </>
  );
};

export default RatingCluppService;
